import { format } from 'date-fns/format';
import { getFormattedDate as getFormattedDateTime } from '@app/utils/commonUtils';
import { LABEL_STATUS, VARIANT_ORDER_STATUS, ORDER_STATUS } from './constants';
import {
  DEFAULT_EXPIRES,
  DISPLAY_DATE,
  ISO_DATE_FORMAT,
  URGENT_EXPIRES_HIGH,
  VARIANT_TYPES
} from '@app/constants/commonConstants';

export const getFilteredSchema = (schema, columnToHide) =>
  schema.filter(item => item.id !== columnToHide);

export const getFormattedDate = (date, dealerDateFormat = DISPLAY_DATE) => {
  const d = new Date(date);
  return format(d, dealerDateFormat);
};

export const getStartAndEndDate = (date, day) => {
  const formattedDate = date ? getFormattedDateTime(day) : '';
  return formattedDate?.split('-').join('/');
};

export const getUTCFormattedDate = date =>
  date ? encodeURIComponent(format(date, ISO_DATE_FORMAT.SHORT_DATE_TIME)) : '';
export const orderExpiresInDaysInt = item => parseInt(item?.orderExpiresInDays);

export const getOrderSeverity = item => {
  const orderExpiresInDays = orderExpiresInDaysInt(item);
  if (!isNaN(orderExpiresInDays) && orderExpiresInDays < URGENT_EXPIRES_HIGH) {
    return LABEL_STATUS.ERRORINFO;
  }
  if (!isNaN(orderExpiresInDays) && orderExpiresInDays <= DEFAULT_EXPIRES) {
    return LABEL_STATUS.WARNING;
  }
  return LABEL_STATUS.DEFAULT;
};
export const getOrderStatusIndicator = statusId => {
  if (
    statusId === VARIANT_ORDER_STATUS.DELETED ||
    statusId === VARIANT_ORDER_STATUS.REJECTED ||
    statusId === VARIANT_ORDER_STATUS.EXPIRED
  ) {
    return VARIANT_TYPES.ERROR;
  }
  if (statusId === VARIANT_ORDER_STATUS.APPROVED) {
    return VARIANT_TYPES.SUCCESS;
  }
  return VARIANT_TYPES.DEFAULT;
};
const allOrdersStatus = ORDER_STATUS.find(({ value }) => !value);
export const getFilteredOrders = (orders, filterStatusId) => {
  const ordersList = Object.values(orders || []);
  if (filterStatusId === allOrdersStatus.value) {
    return ordersList;
  }
  return ordersList.filter(({ statusId }) => statusId === filterStatusId);
};
